import { Modal } from '../../molecules/Modals/Modal/Modal';
import { useTranslation } from 'react-i18next';

interface ClaimExistsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

export function ClaimExistsModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting
}: ClaimExistsModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const modalSettings = {
    kind: 'pop-up' as const,
    settings: {
      title: t('claim.createNewClaim'),
      text: t('claim.claimExistsWarning'),
      primaryButtonText: t('claim.createNewClaim'),
      outlineButtonText: t('claim.keepExistingClaim'),
      handleClose: onClose,
      handlePrimaryClick: onConfirm,
      handleOutlineClick: onClose,
      isSubmitting,
    },
  };

  return (
    <Modal
      className="h-fit w-[350px] rounded-md bg-white"
      kind={modalSettings.kind}
      settings={modalSettings.settings}
    />
  );
}

export default ClaimExistsModal;